import { AuthGuard } from './auth/auth.guard';
import { StagesComponent } from './stages/stages.component';
import { ThankyouComponent } from './stages/thankyou-stage/thankyou-stage.component';
import { AdditionalResourcesComponent } from './additional-resources/additional-resources.component';
import { Routes } from '@angular/router';
import { LaunchResolver } from 'app/auth/launch.resolver';
import { CanDeactivateStage } from 'app/stages/can-deactivate-stage';


export const ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'security/login' },
  { path: 'stages', component: StagesComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateStage] },
  { path: 'launch/:token/:enrollee', component: StagesComponent, resolve: { user: LaunchResolver } },
  { path: 'thankyou', component: ThankyouComponent, canActivate: [AuthGuard] },
  { path: 'additional-resources', component: AdditionalResourcesComponent, canActivate: [AuthGuard] }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts